module.exports = __webpack_public_path__ + "img/logo4.ff55e186.png";